import { debounce } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react'
import { CSVLink } from 'react-csv'
import TableLoading from '../../../core/common/loadingComponent/TableLoading';
import FormattedNumber from '../../../core/common/textFields/FormatNumber';
import DateComp from '../../../core/common/dateComponent/DateComp';
import { svgIcons } from '../../../style/fonts/SvgIcons';
import { useGetAllProjectDetailsQuery, useGetProjectReportListQuery } from '../../../services/EndPointsApis';
import Ribbon from '../../../core/common/ribbon/ribbon';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs'
import { exportStyledExcel } from './ExcelConverter';
import { MbuReportExcel } from './MbuReportExcel';
import { setProjectData } from '../../../Features/commonSlice';
import { useDispatch } from 'react-redux';

const MbuListing = () => {
    const navigate = useNavigate()
    const params = useParams()
    const dispatch = useDispatch()
    const formattedDate = dayjs().format("YYYY-MM-DD_HH-mm-ss");

    const [immediateSearchStr, setImmediateSearchStr] = useState('')
    const [pageSize, setPageSize] = useState(15);
    const [searchStr, setSearchStr] = useState('');
    const [sortBy, setSortBy] = useState("createDT");
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortedColumn, setSortedColumn] = useState("createDT");
    const { data, isLoading, refetch } = useGetProjectReportListQuery({ StatusId: params?.statusId, StartDate: params?.startDate, EndDate: params?.endDate });

    const handleBack = () => {
        navigate("/reports/mbu-report")
    }
    const items = [
        {
            label: "Back",
            tooltipLabel: "Back",
            icon: svgIcons.BackIcon,
            onClick: handleBack,
        },
    ]
    //Search
    const handleSearchChange = (e: any) => {
        const { value } = e.target;
        setImmediateSearchStr(value);
        delayedSearch(value);
    };

    const delayedSearch = useCallback(
        debounce((searchValue) => {
            setSearchStr(searchValue);
        }, 800),
        []
    );
    useEffect(() => {
        if (searchStr === "" ||
            sortOrder === "" ||
            sortBy === "") {
            // refetch();
        }
    }, [searchStr, sortOrder, sortBy]);

    // useEffect(() => {
    //     refetch();
    // }, [setSelectedFilter]);

    const formatNumber = (num: number) => {
        if (num >= 1_000) return `${(num / 1_000)?.toFixed(2)}k`;
        return num?.toString();
    };

    useEffect(() => {
        refetch()
    }, [])

    //csv data 
    const headers = [
        { label: "Business Uint Name", key: "teamName" },
        { label: "ProjectNbr", key: "job" },
        { label: "LastName", key: "lastName" },
        { label: "City", key: "city" },
        { label: "OrigContractAmt", key: "originalContractAmount" },
        { label: "CurrentContractAmt", key: "amt" },
        { label: "PCCAddendaSales", key: "status" },
        { label: "PCCAddendaCost", key: "permitRcvd" },
        { label: "ProjectStatusName", key: "estRcvd" },
        { label: "StatusID", key: "rdyCons" },
        { label: "ActualPermitRcvdDate", key: "inConstruction" },
        { label: "PlannedPermitRcvdDate", key: "saleDate" },
        { label: "JobCategory", key: "pccAddendaSales" },
        { label: "ProjectManagerName", key: "pccAddendaCosts" },
        { label: "DesignArchitectName", key: "pccAddendaCosts" },
        { label: "ProjectDesignerName", key: "pccAddendaCosts" },
        { label: "CDDesignerName", key: "pccAddendaCosts" },
        { label: "PCCKBDesignerName", key: "pccAddendaCosts" },
        { label: "EstimatorName", key: "pccAddendaCosts" },
        { label: "LeadID", key: "pccAddendaCosts" },
        { label: "BusinessUnitID", key: "pccAddendaCosts" },
        { label: "SiteID", key: "pccAddendaCosts" },
        { label: "RegionID", key: "pccAddendaCosts" },
        { label: "SaleDate", key: "pccAddendaCosts" },
        { label: "City", key: "city" },
        { label: "ReadyForPCCActionDate", key: "pccAddendaCosts" },
        { label: "PCCSignOffActionDate", key: "pccAddendaCosts" },
        { label: "SendToPurchase", key: "pccAddendaCosts" },
    ];

    const CsvData = data?.result?.map((item: any) => ({
        bussinessUnitName: item.bussinessUnitName ?? "",
        job: item.job ?? "",
        lastName: item.lastName ?? "",
        city: item.city ?? "",
        originalContractAmount: item.originalContractAmount ?? "",
        currentContractAmount: item.currentContractAmount ?? "",
        pccAddendaSales: item.pccAddendaSales ?? "",
        pccAddendaCost: item.pccAddendaCost ?? "",
        projectStatusName: item.projectStatusName ?? "",
        statusId: item.statusId ?? "",
        actualPermitRcvdDate: item.actualPermitRcvdDate ?? "",
        actualEstRcvdDate: item.actualEstRcvdDate ?? "",
        jobCategory: item.jobCategory ?? "",
        projectManagerName: item.projectManagerName ?? "",
        designArchitectName: item.designArchitectName ?? "",
        projectDesignerName: item.projectDesignerName ?? "",
        cdDesignerName: item.cdDesignerName ?? "",
        pcckbDesignerName: item.pcckbDesignerName ?? "",
        estematerName: item.estematerName ?? "",
        leadId: item.leadId ?? "",
        businessUnitId: item.businessUnitId ?? "",
        lst_SiteId: item.lst_SiteId ?? "",
        lst_RegionId: item.lst_RegionId ?? "",
        saleDate: item.saleDate ? dayjs(item.saleDate).format("MMM-DD-YYYY") : "",
        readyForPCC: item.readyForPCC ?? "",
        pccSignOf: item.pccSignOf ?? "",
        inPurchasing: item.inPurchasing ?? ""
    })) || [];

    const handleEdit = (item: any) => {
        navigate(`/projects/editProject/details/${item?.projectId}`);
        dispatch(setProjectData(item?.projectId))
        localStorage.setItem('projectId',item?.projectId)
    }
    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="row">
                    <div className="col-md-12">
                        <Ribbon
                            items={items}
                            // buttonText="+ Add New Project"
                            buttonClass="add-popup ribbon-btn "
                        // onClickbtn={handleAddNewProject}
                        // disabled={!create}
                        />
                        {/* /Page Header */}
                        <div className="card main-card">
                            <div className="card-body">
                                {/* Search */}
                                <div className="search-section">
                                    <div className="row">
                                        <div className="col-md-4 col-sm-8 mb-2 p-2 px-3">
                                            <h4 className="page-title color-red">MBU-Listing</h4>
                                        </div>
                                        <div className="col-md-8 mb-2">
                                            <div className="d-flex flex-column flex-md-row justify-content-end gap-2 ">
                                                {/* <CSVLink data={CsvData} headers={headers} filename={`Project_List ${formattedDate}.csv`} className="btn btn-light-red d-flex justify-content-center gap-1 align-items-center">
                                                    <i className="fa fa-file-export" />
                                                    Export To CSV
                                                </CSVLink> */}
                                                <button className='btn btn-primary' onClick={() => MbuReportExcel(CsvData, formattedDate)}>
                                                    <i className="fa fa-file-export" /> {" "}
                                                    Export To CSV
                                                </button>
                                                {/* <ManageColumn columns={initialColumnProjects} visibleColumns={visibleColumns} onColumnToggle={handleColumnToggle} /> */}
                                                {/* <FilterComponent handlefiltermodel={handlefiltermodel} idValue={idValue} /> */}
                                                {/* <div>
                                                    <div className=" icon-form">
                                                        <span className="form-icon">
                                                            <i className="ti ti-search" />
                                                        </span>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search User"
                                                            value={immediateSearchStr}
                                                            onChange={handleSearchChange}
                                                        />
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    {/* <h5 className="mt-3 mb-3">Pending & Voided Addenda</h5> */}
                                    <div className="col-md-12">
                                        <div className="card card-css">
                                            <div className="card-body p-0">
                                                <div className="table-responsive">
                                                    <table className="table datanew dataTable no-footer table-hover">
                                                        <thead>
                                                            <tr>
                                                                {/* <th></th> */}
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                                <th>Team Name</th>
                                                                <th className='text-center'>Job</th>
                                                                <th className='text-center'>Name</th>
                                                                <th className='text-center'>City</th>
                                                                <th>Original CONTRACT</th>
                                                                <th>Amt. (000s)</th>
                                                                <th className='text-center'>STATUS</th>
                                                                <th className='text-center'>Permit Rcvd</th>
                                                                <th className='text-center'>Est. Rcvd</th>
                                                                <th className='text-center'>Rdy. Cons.</th>
                                                                <th className='text-center'>In Construction</th>
                                                                <th>Complete Date</th>
                                                                <th>PCC Addenda Sales</th>
                                                                <th>PCC Addenda Cost</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {data?.result?.map(
                                                                (data: any, index: any) => (
                                                                    <tr key={data?.id}>
                                                                        {/* <td>
                                                                            <button
                                                                                className="cursor-pointer bg-transparent border-0"
                                                                                data-tooltip-id="my-tooltip-4"

                                                                            onClick={() => handleView(data)}
                                                                            >
                                                                                {svgIcons.eyeIcon}
                                                                            </button>
                                                                        </td> */}
                                                                        <td>
                                                                            {data?.status !== 'Voided' ?
                                                                                <>
                                                                                    {/* {editAddenda && ( */}
                                                                                    <button
                                                                                        data-tooltip-id="my-tooltip-3"
                                                                                        className="cursor-pointer btn-transparent bg-transparent border-0"
                                                                                        onClick={(e) => handleEdit(data)}
                                                                                    >
                                                                                        {svgIcons.updateIcon}
                                                                                    </button>
                                                                                    {/* )} */}
                                                                                </>
                                                                                : ""
                                                                            }
                                                                        </td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td className='text-center'>{data?.bussinessUnitName}</td>
                                                                        <td className='text-center'>{data?.job}</td>
                                                                        <td className='text-center'>{data?.firstName}</td>
                                                                        <td className='text-center'>{data?.city}</td>
                                                                        <td className='text-center'>{formatNumber(data?.originalContractAmount)}</td>
                                                                        <td className='text-center'>{formatNumber(data?.currentContractAmount)}</td>
                                                                        <td className='text-center'>{data?.projectStatusName}</td>
                                                                        <td className='text-center'><DateComp formattedDate={data?.actualPermitRcvdDate} /></td>
                                                                        <td className='text-center'><DateComp formattedDate={data?.actualEstRcvdDate} /></td>
                                                                        <td className='text-center'><DateComp formattedDate={data?.rdyCons} /></td>
                                                                        <td className='text-center'><DateComp formattedDate={data?.inConstruction} /></td>
                                                                        <td className='text-center'><DateComp formattedDate={data?.saleDate} /></td>
                                                                        <td className='text-center'>{data?.pccAddendaSales}</td>
                                                                        <td className='text-center'>{data?.pccAddendaCost}</td>
                                                                    </tr>
                                                                )
                                                            )}
                                                            {isLoading &&
                                                                <TableLoading />
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MbuListing